export default function getEventImage(pictures, description) {
    for (let field in pictures) {
        if (field === description) {
            return pictures[field];
        }
    }
}